export const validator = {
  email_error_invalid: "Ej giltig e-postadress",

  pw_error: "Använd minst 8 tecken och minst en av varje: versal, gemen, siffra",
};
